import { render, staticRenderFns } from "./RoutePlanCard.vue?vue&type=template&id=24b3dfce&scoped=true"
import script from "./RoutePlanCard.vue?vue&type=script&lang=js"
export * from "./RoutePlanCard.vue?vue&type=script&lang=js"
import style0 from "./RoutePlanCard.vue?vue&type=style&index=0&id=24b3dfce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3dfce",
  null
  
)

export default component.exports